import React from "react";
import { Link } from 'react-router-dom';
import './link-card.css';

interface LinkCardProps {
  children: React.ReactNode;
  href: string;
}

export default function LinkCard(props: LinkCardProps) {
  const { children, href } = props;
  return (
    <Link className="card" to={href}>{children}</Link>
  )
}